// emailConfig.ts
export interface EmailConfig {
    serviceId: string;
    templateId: string;
    userId: string;
  }
  
  const emailConfig: EmailConfig = {
    serviceId: "service_ugnmqwp", // Replace with your EmailJS service ID
    templateId: "template_gzpoyxc", // Replace with your EmailJS template ID
    userId: "6TAoNOuHP_OKVF26W", // Replace with your EmailJS user ID
  };
  
  export default emailConfig;
  